import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormControlServiceBase } from '../types/form-control-service.base';

@Injectable()
export class TextAreaFormControlService implements FormControlServiceBase<'textarea'> {

  readonly minRowsSubject = new BehaviorSubject<number>(3);
  readonly maxRowsSubject = new BehaviorSubject<number>(6);

  constructor() { }

}
